
import React, {Component} from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class HistoryDetail extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            message: '',
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            history: '',
            loading: 1
        };
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
       rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    getTicketDetails() {
        fetch(this.state.apiUrl + '/TicketRest/Historydetails/id/' + this.props.match.params.ticketId + '/userAuthKey/' + this.state.userAuthKey)
                .then((Response) => Response.json())
                .then((responseJson) =>
        {
                    responseJson = this.rawjsonparse(responseJson, 1);
                this.setState({
                        loading: 0,
                        history: responseJson.history,
                   
                }) 
        })
    }
    goBack() {
        window.history.back();
    }
 
    getHistoryDetails()
    {
        if (this.state.loading) {
            return (
                <div>
                  <div class="loader-new"></div>
                </div>
            )
        } else {
             return (
                <div class="intranet_body">
                <div class="title mob">
                    <HeaderMob page_name="Ticket History"/>
				</div>
                <h4>Ticket History</h4>
                <div class="row">
                    <div class="col-md-3"><b>History ID </b></div>
                    <div class="col-md-6">{this.state.history.id}</div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-md-3"><b>Revision </b></div>
                    <div class="col-md-6">{this.state.history.created_date} - By : {this.state.history.user_name}</div>
                </div>
                <br/>
                <div class="row">
                    <div class="col-md-3"><b>{this.state.history.field} => {this.state.history.action}</b></div>
                            <div class="col-md-6"><div dangerouslySetInnerHTML={{__html: this.state.history.object_content}} /></div>
                </div>
                <div className="form-section ckeditor">
                            <button type="buttom" name="add_note" id="add_note" className="btn btn-blue mob-btn" onClick={() => this.goBack()}>Back</button>
                </div>
                </div>
             )
         }
    }
    componentDidMount()
    {
            if (!localStorage.getItem('userLogin')) {
                this.setState({redirect: true});
          }
        document.title = "Intranet | History details";
         
        this.getTicketDetails();
    
    } 
    
    render() {
            if (this.state.redirect) {
            return (
              <Redirect to={'/login'} />
            )
          } 
        return (
               <div >
                  <Header brecum_name="Support" brecum_page="History details"/>
                 <div class="right_col">
                 {this.getHistoryDetails()}
                 </div>
                 </div>
                );
    }
}


export default HistoryDetail;


// WEBPACK FOOTER //
// ./src/components/support/HistoryDetails.js